import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import * as Fa from "react-icons/fa";
import storage from "../../Services/Storage";
import { useEffect, useState } from "react";
import {
    createAPIEndpointIssueLogger,
    EndpointIssueLogger,
} from "../../Services/IssueLogger/IssueLoggerService";
import { EndpointUploadDownload } from "../../Services/UploadDownload/UploadDownloadService";
import { toast } from "react-toastify";
import React from "react";
import Loader from "../../Components/Loader";
import { BASE_URL } from "../../api/Axios";

const IssueLogger = () => {
    const auth = storage.getLocal("user");
    const [mailId, setMailId] = useState();
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [comment, setComment] = useState("");
    const [mailSubject, setMailSubject] = useState("");
    const [fileUrl, setFileUrl] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [loader, setLoader] = useState(false);

    const categories = [
        { label: "User Assistance/Question", value: "user_assistance" },
        { label: "Data", value: "data" },
        { label: "System", value: "system" },
        { label: "Network", value: "network" },
    ];

    const resetform = () => {
        setSelectedCategories(null);
        setMailSubject("");
        setFileUrl("");
        setComment("");
        setFileUrl(null);
    };
    const getMailId = async () => {
        try {
            const response = await createAPIEndpointIssueLogger().get(
                `${EndpointIssueLogger.GetMailId}?UserId=${auth.UserId}&CompId=${auth.CompId}`
            );
            setMailId(response.data[0]?.EMP_EMAILID);
        } catch (err) {
            console.log("Error ", err);
        }
    };

    const createPayload = () => {
        return {
            useR_ID: auth.UserId,
            comP_ID: auth.CompId,
            useR_MAIL: mailId,
            maiL_SUBJECT: mailSubject,
            category: selectedCategories,
            msg: comment,
            attachmenT_PATH: fileUrl || "",
            status: "Y",
            entereD_BY: auth.UserId,
        };
    };

    const SaveUserMailDetails = async () => {
        console.log(selectedCategories);
        if (mailSubject.toString().trim().length == 0) {
            toast.warn("Subject can not be blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }

        if (comment.toString().trim().length == 0) {
            toast.warn("Comments can not be blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (selectedCategories == null) {
            toast.warn("Choose a category", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        const payload = createPayload();
        try {
            setLoader(true);
            let resdata = await createAPIEndpointIssueLogger().post(
                `${EndpointIssueLogger.SaveUserMailDetails}`,
                payload
            );
            toast.success(`${resdata.data}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 4000,
            });
            resetform();
        } catch (error) {
            console.log("Error ", error);
        } finally {
            setLoader(false);
        }
    };
    const handleUpload = (event) => {
        const response = JSON.parse(event.xhr.response);
        setFileUrl(response.FileUrl);

    };

    useEffect(() => {
        getMailId();
    }, []);

    const handleError = (e) => {
        if (e.files && e.files.length > 0) {
            // Check if the file type is .zip
            if (e.files[0].type !== "application/zip") {
                setErrorMessage("Only .zip files are allowed.");
            }
            // Check if the file size exceeds 2MB
            else if (e.files[0].size > 2000000) {
                setErrorMessage("File size exceeds the 2MB limit.");
            } else {
                setErrorMessage("");
            }
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Issue Logger</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={SaveUserMailDetails}
                            >
                Submit
                            </button>
                        </div>
                    </div>
                </div>

                {loader?<><Loader/></>:<section>
                    <div className="sales-box">
                        <form>
                            <div className="row dash-brder-bottom mb-3 pb-3">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">Mail</label>
                                        <InputText
                                            className="form-control"
                                            value={mailId}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Mail Subject <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            placeholder="Subject"
                                            value={mailSubject}
                                            onChange={(e) => setMailSubject(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Categories <span className="mandatory">*</span>
                                        </label>
                                        <Dropdown
                                            options={categories}
                                            optionLabel="label" // Use the label field for displaying options
                                            value={selectedCategories}
                                            onChange={(e) => setSelectedCategories(e.value)} // Use the value field for the underlying value
                                            placeholder="Select a Category"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Comments <span className="mandatory">*</span>
                                        </label>
                                        <InputTextarea
                                            className="form-control"
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                            maxLength={2000}
                                        />
                                        <small className="p-error mt-2 text-end">
                      Character left : {2000 - comment.length}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <h5>Select File To Import</h5>
                                <div className="row d-flex justify-content-center align-items-center">
                                    <div className="col-lg-8 col-md-12 col-sm-12 clearfix">
                                        <div className="UploadSection clearfix">
                                            <div className="conText">
                                                {" "}
                                                <Fa.FaInfoCircle className="icon" /> Select Only Zip
                        File To Upload
                                            </div>
                                            {/* <FileUpload
                        name="file"
                        className="clearfix nTopMargin"
                        url={`https://innorisedmsdevapi.azurewebsites.net/api/UploadDownload/${EndpointUploadDownload.UploadFile}?FilePath=ISSUE_LOGGER`}
                        multiple
                        accept="image/*"
                        maxFileSize={1000000}
                        onUpload={handleUpload}
                        emptyTemplate={
                          <p className="m-0">
                            Drag and drop files to here to upload.
                          </p>
                        }
                      /> */}
                                            <FileUpload
                                                name="file"
                                                className="clearfix nTopMargin"
                                                url={`${BASE_URL}/UploadDownload/${EndpointUploadDownload.UploadFile}?FilePath=ISSUE_LOGGER`}
                                                multiple
                                                accept=".zip" // Accept only zip files
                                                maxFileSize={2000000} // Max file size 2MB
                                                onUpload={handleUpload}
                                                onError={handleError} // Handle errors like file type and size
                                                emptyTemplate={
                                                    <p className="m-0">
                            Drag and drop files here to upload.
                                                    </p>
                                                }
                                            />
                                            {errorMessage && (
                                                <p style={{ color: "red" }}>{errorMessage}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="text-end">
                                            <img
                                                src={require("../../Assets/Images/File_Upload.png")}
                                                className="File_Upload_Img drop-right"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>}

        
            </div>
        </>
    );
};

export default IssueLogger;
